(() => {
  if (window.__uniAdmissionChecklist) return;
  const instances = new Map();
  const contactSelector = '[data-uni-contact][data-mode="institutional"][data-purpose="admissions"]';
  const within = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  function initialize(root = document) {
    within(root, '[data-admission-checklist]').forEach((section) => {
      if (instances.has(section)) return;
      const selector = section.querySelector('[data-admission-select]');
      const programs = [...section.querySelectorAll('[data-admission-program]')];
      const controls = section.querySelector('[data-admission-controls]');
      const actions = section.querySelector('[data-admission-actions]');
      const empty = section.querySelector('[data-admission-empty]');
      if (!selector || !programs.length || !controls || !actions || !empty) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const continueLink = section.querySelector('[data-admission-continue]');
      const fallbackUrl = continueLink?.getAttribute('href') || '';
      controls.hidden = false;
      section.dataset.enhanced = 'true';
      section.dataset.checklistBound = 'true';
      let syncedProgram = '';
      const getSelected = () => programs.find((program) => program.dataset.admissionProgram === selector.value);
      const progress = (program) => {
        const output = program?.querySelector('[data-admission-progress]');
        if (!output) return;
        const checks = [...program.querySelectorAll('[data-admission-check]')];
        const done = checks.filter((check) => check.checked).length;
        output.textContent = (section.dataset.progress || '').replace('[[done]]', done).replace('[[total]]', checks.length);
        const segments = program.querySelector('[data-admission-segments]');
        if (segments) {
          if (segments.children.length !== checks.length) segments.replaceChildren(...checks.map(() => document.createElement('span')));
          [...segments.children].forEach((segment, index) => { segment.dataset.complete = String(index < done); });
        }
      };
      const syncForm = () => {
        document.querySelectorAll(`${contactSelector} [data-contact-program]`).forEach((field) => {
          const option = [...field.options].find((item) => item.dataset.programId === selector.value);
          if (option) { field.value = option.value; field.dispatchEvent(new Event('change', { bubbles: true })); }
          else if (!selector.value && syncedProgram && [...field.options].some((item) => item.value === field.value && item.dataset.programId === syncedProgram)) {
            field.value = '';
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        syncedProgram = selector.value;
      };
      const updateDestination = () => {
        if (!continueLink) return;
        const localForm = document.querySelector(contactSelector);
        if (localForm?.id) {
          continueLink.setAttribute('href', `#${localForm.id}`);
          return;
        }
        try {
          const target = new URL(fallbackUrl, location.origin);
          if (target.origin === location.origin && getSelected()) target.searchParams.set('programa', selector.value);
          continueLink.href = target.href;
        } catch { continueLink.setAttribute('href', fallbackUrl); }
      };
      const update = (share = false) => {
        const selected = getSelected();
        programs.forEach((program) => { program.hidden = program !== selected; program.open = program === selected; });
        empty.hidden = Boolean(selected);
        actions.hidden = !selected;
        progress(selected);
        if (selected || syncedProgram) syncForm();
        updateDestination();
        if (share) {
          const url = new URL(location.href);
          if (selected) url.searchParams.set('programa', selector.value);
          else url.searchParams.delete('programa');
          history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
        }
      };
      const requested = new URLSearchParams(location.search).get('programa');
      if (programs.some((program) => program.dataset.admissionProgram === requested)) selector.value = requested;
      selector.addEventListener('change', () => update(true), options);
      section.addEventListener('change', (event) => { if (event.target.matches('[data-admission-check]')) progress(getSelected()); }, options);
      continueLink?.addEventListener('click', () => {
        syncForm();
        updateDestination();
        const target = document.querySelector(`${contactSelector} input:not([type="hidden"])`);
        if (target) target.focus({ preventScroll: true });
      }, options);
      section.querySelector('[data-admission-print]')?.addEventListener('click', async () => {
        const selected = getSelected();
        if (!selected) return;
        selected.open = true;
        const date = section.querySelector('[data-admission-print-date]');
        if (date) {
          const now = new Date();
          date.dateTime = now.toISOString();
          date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'es-CO', { dateStyle: 'long' }).format(now);
        }
        const logo = section.querySelector('.uni-admission__print-logo');
        if (logo?.decode && !logo.complete) await Promise.race([logo.decode().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 1200))]);
        if (!section.isConnected || controller.signal.aborted) return;
        document.body.classList.add('uni-print-admission');
        section.dataset.printActive = 'true';
        window.print();
      }, options);
      const afterPrint = () => { document.body.classList.remove('uni-print-admission'); delete section.dataset.printActive; };
      window.addEventListener('afterprint', afterPrint, options);
      instances.set(section, () => {
        controller.abort();
        if (section.dataset.printActive) afterPrint();
        delete section.dataset.checklistBound;
        delete section.dataset.enhanced;
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((cleanup, section) => {
      if (event.target === section || event.target.contains(section)) { cleanup(); instances.delete(section); }
    });
  });
  window.__uniAdmissionChecklist = true;
})();
